import { useWatch } from 'react-hook-form';

import { FormRow } from '@creditornot/cb-form';
import { Textarea } from '@creditornot/cb-input';
import { FormField } from 'common/components/cookbook/FormField';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const CommentRow = () => {
  const f = useFormatMessage();

  const { reason: reasonValue } = useWatch();
  const required = reasonValue === 'OTHER' ? f('common.validation.required') : undefined;

  return (
    <FormRow label={f('selection_recommendations.comment_label')} required={!!required}>
      <FormField
        name="comment"
        rules={{
          required,
          validate: (value) => {
            if (value) {
              return !!value.trim() || f('common.validation.required');
            }
            return undefined;
          },
        }}
        renderInput={(props) => (
          <Textarea
            {...props}
            placeholder={f('selection_recommendations.comment_field_placeholder')}
            rows={3}
            title="comment"
          />
        )}
      />
    </FormRow>
  );
};
